import { useState } from "react";
import { useImageScale } from "../../../hooks/useImageScale";
//import "./ImageGrid.css";
import "./ImageCell.css";
const LazyImage = ({ src, alt = "", onLoad, hovered, containerRef }) => {
  const [naturalSize, setNaturalSize] = useState({ w: 0, h: 0 });

  const handleLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    setNaturalSize({ w: naturalWidth, h: naturalHeight });

    /*if (onLoad) {
      onLoad(e);
    }*/
    onLoad?.(e); // Appelle la fonction de callback passée par le parent
  };

  const scale = useImageScale(containerRef, naturalSize, hovered);
  //console.log("scale,scale",scale);
  //const scale = useImageScale(naturalSize, hovered);
  return (
    <>
      <img
      opacity={0}
        src={src}
        alt={alt}
        className="grid-image"
        onLoad={handleLoad}
        loading="lazy"
        draggable={false}
        style={{
          transform: `scale(${scale})`,
          transformOrigin: "center center",
          transition: "transform 0.5s ease, opacity 0.5s ease",
          opacity:1,
        }}
      />
    </>
  );
};

export default LazyImage;
